import jwtDecode from "jwt-decode";
import http from "./http";
import { BASEURL, KEYACTION } from "./url";
const CryptoJS = require('crypto-js');


export const getToken = () => {
  return localStorage.getItem("token") ?? "";
};


export const actions = {
  IniciarSesion: 900,
  PlantillaMasterDocVer: 1000,
  PlantillaMasterDocCrear: 1001,
  PlantillaMasterDocEditar: 1002,
  PlantillaMasterDocEliminar: 1003,
  PLantillasMasterDocUltimaVersionVer: 1004,
  PlantillaMasterDocInfoReducidaVer: 1005,
  RestriccionVer: 2000,
  RestriccionCrear: 2001,
  RestriccionEditar: 2002,
  RestriccionEliminar: 2003,
  UsuariosVer: 3000,
  UsuariosCrear: 3001,
  UsuariosEditar: 3002,
  UsuariosEliminar: 3003,
  PerfilesVer: 4000,
  PerfilesCrear: 4001,
  PerfilesEditar: 4002,
  PerfilesEliminar: 4003,
  ParametriaVer: 5000,
  ParametriaEditar: 5001,
  DiccionarioVer: 6000,
  DiccionarioCrear: 6001,
  DiccionarioEditar: 6002,
  DiccionarioEliminar: 6003
}

// const encryptActions = (actions) => {
//   let response = CryptoJS.AES.encrypt(JSON.stringify(actions), KEYACTION).toString();
//   return response;
// };

// export const getActions = () => {
//   return new Promise((resolve, reject) => {
//     http.get(`${BASEURL}/accion`)
//       .then((response) => {
//         const data = response.data;
//         const actions = data.reduce((acc, accion) => {
//           acc[accion.nombre] = accion.id;
//           return acc;
//         }, {});
//         let actionsEncrypt = encryptActions(actions);
//         sessionStorage.setItem("actions", JSON.stringify(actionsEncrypt));
//         resolve(actions);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch actions:", error);
//         reject(error);
//       });
//   });
// };

// export const decryptActions = () => {
//   let actionsEncrypted = sessionStorage.getItem("actions");
//   if (!actionsEncrypted) {
//     return null; // O maneja el caso en el que no se hayan obtenido las acciones
//   }
//   const decryptedId = CryptoJS.AES.decrypt(actionsEncrypted, KEYACTION).toString(CryptoJS.enc.Utf8);
//   let decryptedActions = JSON.parse(decryptedId);
//   return decryptedActions;
// };

// // Llamada a getActions y posteriormente asignar el valor a export const actions
// export let actions = null;

// getActions()
//   .then((actionsData) => {
//     actions = actionsData;
//   })
//   .catch((error) => {
//     console.error("Failed to get actions:", error);
//   });


export const hasPermission = (action) => {
  let usuario = jwtDecode(getToken());
  let result = JSON.parse(usuario.acciones)
  return result.indexOf(action) > -1;
};
export const hasPermissionRestrict = (action, codMasterDoc) => {
  let usuario = jwtDecode(getToken());
  let restricciones = JSON.parse(usuario.restricciones);
  let result = restricciones.map((restriccion) => {
    if (restriccion.CodMasterDoc === codMasterDoc) {
      return restriccion.Restricciones.indexOf(action) > -1;
    }
  });
  return result.indexOf(true) > -1;
}

export const hasRestrictContent = () => {
  let usuario = jwtDecode(getToken());
  let restricciones = JSON.parse(usuario.restricciones);
  return restricciones.length > 0;
}

